import type { IPathBaseParam } from "./path";

import type { IUsersResponse } from "@api/users/types";
import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IUserBulkDto } from "@api/users/bulk/types";

const postApis = createPostApi<
  IApiResponse<IUsersResponse>,
  IPathBaseParam,
  IUserBulkDto
>("users.bulk");

export const bulk = {
  ...postApis,
};
